<div class="container" [ngClass]="{'increase-height': isBusinessUser}">
    <xm-sub-nav *ngIf="isBusinessUser"></xm-sub-nav>
    <nav class="main-nav" [ngClass]="{'mobile-open': isMobileNavOpen, 'mobile-closed': !isMobileNavOpen}" role="navigation">
        <button class="skip-content" role="link" *ngIf="!hideSkipToContent" (click)="focusContent()">{{ pageData.skipContentText }}</button>

        <div class="links">
            <div class="left">
                <xm-nav-logo></xm-nav-logo>
                <div *ngFor="let menuItem of desktopMenuItems" class="desktop-menu-items">
                    <xm-nav-menu-item [pageData]="menuItem" [showChildren]="true"></xm-nav-menu-item>
                </div>
            </div>
            <div *ngIf="isBusinessUser && account && !isCBMAccountSelectorEnabled && !isOrionAccountSelectorEnabled" class="account-info">
                <p *ngIf="!isOrionTenant">{{myAccountMenuItems.accountFullLabel}} <span class="strong">#{{account.cableAccountNumber}}</span></p>
                <p class="account-address">{{ serviceAddress.address1 }} <span *ngIf="serviceAddress.address2">{{ serviceAddress.address2 }}</span><span>{{ serviceAddress.city }}, {{ serviceAddress.state }} {{ serviceAddress.zip }}</span></p>
                <div class="tool-tip">
                    <p *ngIf="!isOrionTenant" class="account-no">{{myAccountMenuItems.accountShortLabel}} <span>#{{account.cableAccountNumber}}</span></p>
                    <p>{{ serviceAddress.address1 }}</p>
                    <p *ngIf="serviceAddress.address2">{{ serviceAddress.address2 }}</p>
                    <p>{{ serviceAddress.city }}, {{ serviceAddress.state }} {{ serviceAddress.zip }}</p>
                </div>
            </div>
            <div class="right" [ngClass]="{'linked-accounts': isLinkedAccountSelector}">
                <cbm-nav-menu-item class="my-account" *ngIf="isLinkedAccountSelector" [linkedAccounts]="linkedAccounts"></cbm-nav-menu-item>
                <xm-nav-menu-item [pageData]="myAccountMenuItems" [showChildren]="showMyAccountChildren" class="my-account" [inheritParentWidth]="true"></xm-nav-menu-item>
                <div *ngFor="let menuItem of pageData.desktopRightMenuItems" class="desktop-menu-items">
                    <xm-nav-menu-item [pageData]="menuItem" [showChildren]="true"></xm-nav-menu-item>
                </div>
            </div>
            <div role="alert" class="logout-alert accessibility-hidden"></div>
        </div>

        <div class="mobile-links">
            <xm-nav-hamburger #xmNavHamburgerRoot [triggerOnChanges]="checkHamburgerNavExpanded" (isMobileNavExpand)="isMobileNavExpand($event)" (focusout)="focusoutHamburgerMenu($event)"></xm-nav-hamburger>
            <xm-nav-logo (closeHamburgerNavFromLogo)="closeHamburgerNavMenu()"></xm-nav-logo>
            <xm-nav-cart *ngIf="!isBusinessUser" class="mobile-cart" (toggleMobileNav)="closeHamburgerNavMenu()"></xm-nav-cart>
        </div>
    </nav>
</div>
